import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "BookingFeatureList",
  data: () => ({
    newFeatureGroupTitle: "",
    editedItem: {}
  }),
  async mounted() {
    await this.$store.dispatch("getBookingFeatures", { ignorePrincipalId: 1 });
  },
  methods: {
    addNewFeature(featureGroupId) {
      this.editedItem = {
        title: "",
        featureGroup: featureGroupId,
        isInternalFeature: false
      };
    },
    async saveFeature() {
      try {
        if (!this.editedItem?._id) await this.createFeature();
        else await this.updateFeature();
        this.editedItem = {};
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async createFeature() {
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.booking_api_client_url}feature`,
          this.editedItem,
          { headers }
        );
        if (response.status === 201)
          await this.$store.dispatch("createSuccess", "Erfolgreich erstellt!");
        else await this.$store.dispatch("createError", response.data);

        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async updateFeature() {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.booking_api_client_url}feature/${this.editedItem._id}`,
          this.editedItem,
          { headers }
        );
        if (response.status === 200)
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        else await this.$store.dispatch("createError", response.data);

        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async editFeature(feature, featureGroupId) {
      this.editedItem = { ...feature, featureGroup: featureGroupId };
    },
    async deleteFeature(featureId) {
      try {
        const headers = getTokenHeader();
        const response = await axios.delete(
          `${env.booking_api_client_url}feature/${featureId}`,
          { headers }
        );
        if (response.status === 200)
          await this.$store.dispatch("createSuccess", "Erfolgreich gelöscht");
        else await this.$store.dispatch("createError", response.data);

        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async addFeatureGroup() {
      try {
        const headers = getTokenHeader();
        const newFeatureGroup = {
          title: this.newFeatureGroupTitle,
          principals: [this.currentPrincipal]
        };
        const response = await axios.post(
          `${env.booking_api_client_url}featureGroup`,
          newFeatureGroup,
          { headers }
        );
        if (response.status === 201)
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich hinzugefügt"
          );
        else await this.$store.dispatch("createError", response.data);
        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async updateSubscribedFeatureGroups(value) {
      const currentlySubscribed = this.featureGroups
        .filter(group => group.principals.includes(this.currentPrincipal))
        .map(group => group._id);

      const noLongerSubscribed = currentlySubscribed.filter(
        group => !value.includes(group)
      );

      const newlySubscribed = value.filter(
        group => !currentlySubscribed.includes(group)
      );
      await noLongerSubscribed.asyncForEach(async group => {
        const foundGroup = this.featureGroups.find(fg => fg._id === group);
        if (!foundGroup) return;
        foundGroup.principals = foundGroup.principals.filter(
          p => p !== this.currentPrincipal
        );
        await this.updateFeatureGroup(foundGroup);
      });
      await newlySubscribed.asyncForEach(async group => {
        const foundGroup = this.featureGroups.find(fg => fg._id === group);
        if (!foundGroup) return;
        foundGroup.principals.push(this.currentPrincipal);
        await this.updateFeatureGroup(foundGroup);
      });
    },
    async updateFeatureGroup(featureGroup) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.booking_api_client_url}featureGroup/${featureGroup._id}`,
          featureGroup,
          { headers }
        );
        if (response.status === 200)
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        else await this.$store.dispatch("createError", response.data);
        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    },
    async deleteFeatureGroup(featureGroupId) {
      try {
        const headers = getTokenHeader();
        const response = await axios.delete(
          `${env.booking_api_client_url}featureGroup/${featureGroupId}`,
          { headers }
        );
        if (response.status === 200)
          await this.$store.dispatch("createSuccess", "Erfolgreich gelöscht");
        else await this.$store.dispatch("createError", response.data);

        await this.$store.dispatch("getBookingFeatures", {
          ignorePrincipalId: 1
        });
      } catch (e) {
        await this.$store.dispatch("createError", e);
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    featureGroups() {
      return this.$store.state.bookingFeatureGroups;
    },
    selectedFeatureGroups() {
      return this.featureGroups.filter(group =>
        group.principals.includes(this.currentPrincipal)
      );
    }
  }
};
